import React from 'react';
import { Card } from '@ncoder/ui';
import { MonitoringMetric } from '../../atoms/deployment';
import { Activity, Clock, TrendingUp, AlertTriangle } from 'lucide-react';

interface Metrics {
  uptime: string;
  requests: string;
  responseTime: string;
  errors: string;
}

interface DeploymentMonitoringProps {
  metrics: Metrics;
}

export const DeploymentMonitoring: React.FC<DeploymentMonitoringProps> = ({
  metrics,
}) => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Performance Metrics</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <MonitoringMetric
          label="System Uptime"
          value={metrics.uptime}
          change="+2%"
          changeType="positive"
          icon={<Activity className="h-4 w-4" />}
          color="success"
        />
        <MonitoringMetric
          label="Requests/Min"
          value={metrics.requests}
          change="+15%"
          changeType="positive"
          icon={<TrendingUp className="h-4 w-4" />}
          color="primary"
        />
        <MonitoringMetric
          label="Avg Response Time"
          value={metrics.responseTime}
          change="-8ms"
          changeType="positive"
          icon={<Clock className="h-4 w-4" />}
          color="primary"
        />
        <MonitoringMetric
          label="Error Rate"
          value={metrics.errors}
          change="-0.1%"
          changeType="positive"
          icon={<AlertTriangle className="h-4 w-4" />}
          color="warning"
        />
      </div>
    </Card>
  );
};
